import { useNavigate, useState } from "@modica-library/react19";
import { ModicaIcon } from "@modica-library/icons/react";
import "./ProgressGuide.css";

type GuideItem = { id: string; label: string; to?: string; bonus?: boolean };

// Items with a route navigate there; the rest are placeholders until built.
const ITEMS: GuideItem[] = [
  { id: "send", label: "Send a Message", to: "/dashboard/send" },
  { id: "reply", label: "Reply from Inbox", to: "/dashboard/inbox" },
  { id: "contacts", label: "Add Contacts and Groups" },
  { id: "blast", label: "Send a Blast" },
  { id: "bonus", label: "Claim 50 BONUS Credits", bonus: true },
];

/** Floating demo-progress guide — fixed bottom-right, collapsible. `completed` (item ids)
 *  drives the progress bar and check state; wire it to real completion as flows are built. */
export function ProgressGuide({ completed = [] }: { completed?: string[] }) {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const doneCount = ITEMS.filter((i) => completed.includes(i.id)).length;
  const pct = Math.round((doneCount / ITEMS.length) * 100);

  return (
    <aside className={`guidebox${open ? "" : " guidebox--collapsed"}`} aria-label="Demo progress guide">
      <button className="guidebox__head" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <span className="guidebox__heading">
          <span className="guidebox__title">Demo Guide</span>
          <span className="guidebox__sub">
            {doneCount} of {ITEMS.length} complete
          </span>
        </span>
        <span className="guidebox__chevron">
          <ModicaIcon iconName="expand_more" color="white" decorative />
        </span>
      </button>

      <div className="guidebox__track">
        <span className="guidebox__fill" style={{ width: `${pct}%` }} />
      </div>

      <div className={`guidebox__collapse${open ? " is-open" : ""}`}>
        <div className="guidebox__collapse-inner">
          <ul className="guidebox__list">
            {ITEMS.map((i) => {
              const isDone = completed.includes(i.id);
              return (
                <li key={i.id}>
                  <button
                    type="button"
                    className={`guideitem${isDone ? " is-done" : ""}${i.bonus ? " is-bonus" : ""}`}
                    onClick={() => i.to && navigate(i.to)}
                  >
                    <span className="guideitem__status">
                      <ModicaIcon iconName={isDone ? "check_circle" : "radio_button_unchecked"} color="black" decorative />
                    </span>
                    <span className="guideitem__label">{i.label}</span>
                    <span className="guideitem__go">
                      <ModicaIcon iconName="chevron_right" decorative color="black" />
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </aside>
  );
}
